<!-- 商品详情页面 -->
<template>
  <div id="details" class="stockDetails">
    <!-- 主要内容 -->
    <div class="main">
      <div class="detail-goods-info">
        <div class="goods-image">
          <div class="left">
            <pic-zoom v-if="currentImage" class="leftImg" url="https://img0.baidu.com/it/u=2332624306,2869992322&fm=253&fmt=auto&app=120&f=JPEG?w=500&h=889" :scale="3" />
            <pic-zoom v-else class="leftImg" :url="dataimg" :scale="3" />
          </div>
          <div class="goodsImage-list">
            <div class="goods-button" style="margin-right: 10px" @click="prevImage">
              <i class="el-icon-arrow-left" style="color: #999" />
            </div>
            <ul
              :style="{
                'margin-left': numImage * 35 + 'px',
                transition: 'all .3s ease-out .1s',
              }"
            >
              <li v-for="(item, index) in ImageList" :key="index">
                <img :src="item.RotationMapUrl" alt="" @click="selectGoodsImage(item)">
              </li>
            </ul>
            <div class="goods-button" @click="nextImage">
              <i class="el-icon-arrow-right" style="color: #999" />
            </div>
          </div>
        </div>
        <!-- 左侧商品轮播图END -->

        <!-- 右侧内容区 -->
        <div class="content">
          <h1 class="name">{{ detailsList ? detailsList.FStockName : "" }}</h1>
          <div class="content-price">
            <template v-if="detailsList.IsDirectoryPool">
              <div class="my-price" style="font-weight: bold;">
                企业专享价:
                <template v-if="FPriceShow">
                  <span class="big-red">{{
                    detailsList.fStockPrice ? _stockPrice(detailsList.fStockPrice,detailsList.FTPriceDecimal) : 0.00
                  }}</span>
                  <span style="color: #ec2631">{{
                    detailsList.FMeasurement ? '/' + detailsList.FMeasurement : ""
                  }}</span>
                </template>
                <span v-else id="noShowPrice" style="margin:0;">
                  <span style="margin:0;">￥</span>价格不可见
                </span>
              </div>
              <div class="old-price">
                <span style="font-weight: bold;margin-right: 12px;">商城含税价:</span>
                <template v-if="FPriceShow">
                  ¥
                  <span class="price-black">{{
                    detailsList.FPrice ? FixedTo(detailsList.FPrice) : 0.00
                  }}</span>{{ detailsList.FMeasurement ? '/' + detailsList.FMeasurement : "" }}
                </template>
                <span v-else id="noShowPrice" style="margin:0;">
                  <span style="margin:0;">￥</span>价格不可见
                </span>
              </div>
            </template>
            <div v-else class="noPool">
              不在目录池
            </div>

          </div>
          <div class="goods-manufactor">
            <div class="item">
              <span class="colordata">品牌名称:</span>
              <span>{{ detailsList ? detailsList.FMarkName : "" }}</span>
            </div>
            <div class="item shortCode">
              <span class="colordata">订货编码:</span>
              <span>{{
                detailsList ? detailsList.FShortCode.slice(0, 9) : ""
              }}</span>
            </div>
            <div class="item">
              <span class="colordata titleLength">需方编码:</span>
              <span
                v-if="detailsList.FDemandStcokCode"
                style="cursor: pointer;display: flex;"
                @click.stop="copyCode(detailsList.FDemandStcokCode,1)"
              >
                <span class="itemLength">{{ detailsList ? detailsList.FDemandStcokCode.slice(0, 9) : "" }}</span>
                <!-- <el-tooltip class="item" effect="dark" :content="detailsList.FDemandStcokCode" placement="top">
                </el-tooltip> -->
                <i class="el-icon-document-copy" />
              </span>
            </div>
            <div class="item">
              <span class="colordata">厂家货号:</span>
              <span>{{ detailsList ? detailsList.FFactoryCode : "" }}</span>
            </div>

            <div class="item">
              <span class="colordata">起 订 量:</span>
              <span>{{ detailsList ? detailsList.FOrderQuantity : "" }}</span>
            </div>
            <div class="item">
              <span class="colordata">包 装 量:</span>
              <span>{{ detailsList ? detailsList.FMinPackQuanty : "" }}</span>
            </div>
          </div>
          <div style="height:106px;" class="goods-manufactor">
            <div class="item">
              <span class="colordata">发货日:</span>
              <el-tooltip
                v-if="detailsList.fDeliveryInfo"
                class="item"
                effect="dark"
                :content="detailsList.fDeliveryInfo"
                placement="top-start"
              >
                <div class="tag">
                  {{ detailsList.fDeliveryInfo | delivery }}
                </div>
              </el-tooltip>
            </div>
            <div class="item">
              <span class="colordata">发货地:</span>
              <div v-if="detailsList.webareaFLevelName" class="shipment-place">
                <i class="el-icon-location-outline" />
                {{ assderFilt(detailsList.webareaFLevelName) }}
              </div>
            </div>
            <div class="item">
              <span class="colordata">商品服务:</span>
              <span><svg-icon style="margin-right: 5px;" icon-class="zpbz" />正品保证</span>
            </div>
            <div class="item">
              <span><svg-icon style="margin-right: 5px;" icon-class="shwy" />售后无忧</span>
            </div>
          </div>
          <div class="goods-operation">
            <div v-if="detailsList.IsDirectoryPool">
              <span class="collection" @click="Collection(flagData)">
                <span class="iconEnter">
                  <svg-icon :icon-class="!flagData ? 'collection2' : 'collection'" /></span>
                <span :class="!flagData ? '' : 'writeText'">{{ !flagData ? '已收藏' : '收藏' }}</span>
              </span>
            </div>
            <div>
              <el-popover placement="top-start" width="360" trigger="hover">
                <div v-for="(t,i) in contacts" :key="i">
                  <span>
                    <svg-icon style="margin-right: 5px;" icon-class="red-user" /> 联系人：{{ t.FLinkman }}
                  </span>
                  <span style="margin-left:15px;">
                    <svg-icon style="margin-right: 5px;" icon-class="newPhone" /> 联系方式：{{ t.FTelNo }}
                  </span>
                </div>
                <span slot="reference" style="color: #666666;">
                  <svg-icon icon-class="new-phone" />联系我们
                </span>
              </el-popover>
            </div>
          </div>
          <!-- 内容区底部按钮 -->
          <div v-if="detailsList.IsDirectoryPool" class="goods-payButton">
            <div>
              <el-input-number
                v-model="goodsNum"
                :precision="detailsList.FQuantyDecimal"
                :min="detailsList.min"
                :max="99999"
                size="large"
                @change="handleChange"
              />
            </div>
            <div
              :class="fpurchaseMode ? 'pay-button no-pay' : 'pay-button'"
              style="cursor: pointer"
              @click="gopurchase(detailsList)"
            >
              <img class="buy-img" src="@/assets/images/buy.png" alt="">立即购买
            </div>
            <div>
              <el-button class="addCart" @click="addShoppingCart(detailsList,goodsNum,true)">
                <svg-icon icon-class="cart" />
                加入购物车</el-button>
            </div>
          </div>
          <!-- 内容区底部按钮END -->
        </div>
      </div>
      <!-- 右侧内容区END -->
      <!-- 店铺推荐 -->
      <!-- <div class="shop-recommend">
        <p class="shop-title">平台推荐</p>
        <div class="shop-list">
          <div class="shop-button" style="margin-right: 10px" @click="prev">
            <i class="el-icon-arrow-left" style="color: #999" />
          </div>
          <ul
            :style="{
              'margin-left': num * 285 + 'px',
              transition: 'all .3s ease-out .1s',
            }"
          >
            <li
              v-for="(item, index) in recommendList.PageList"
              :key="index"
              style="cursor: pointer"
              @click="shopItemClick(item)"
            >
              <img v-if="item.FCover" :src="item.FCover" alt="">
              <img v-else :src="dataimg" alt="">
              <p class="shop-info">
                <span class="shop-info-name">{{ item.FStockName }}</span>
                <span v-if="FPriceShow" class="shop-info-price">{{
                  item.fStockPrice ? item.fStockPrice : 0
                }} {{ item.FMeasurement ? '/' + item.FMeasurement : "" }}</span>
                <span v-else id="noShowPrice" style="margin:0;text-align: left;">
                  <span style="margin:0;">￥</span>价格不可见
                </span>
              </p>
            </li>
            <div>
              <img
                style="width: 270px; height: 116px"
                src="../../../assets/images/bg-shop.png"
                alt=""
              >
            </div>
          </ul>
          <div class="shop-button" @click="next">
            <i class="el-icon-arrow-right" style="color: #999" />
          </div>
        </div>
      </div> -->
      <!-- 店铺推荐 END-->
      <!-- 下方详情 -->
      <div class="comdity-detail">
        <aside class="comdity-detail-left">
          <nav class="comdity-detail-aside-nav">
            <span>
              <div class="diamond" />规格参数</span>
            <el-button @click="clearParamList">清空筛选</el-button>
          </nav>
          <!--规格参数-->
          <el-menu
            default-active="2"
            class="el-menu-vertical-demo"
            text-color="#202020"
            active-text-color="#EC212D"
            :default-openeds="opends"
            @open="handleOpen"
            @close="handleClose"
          >
            <el-submenu v-for="(item, index) in paramsData" :key="index + 1" :index="`${index + 2}`">
              <template slot="title">
                <span>{{ item.FpropName }}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item :index="`${index + 2}`">
                  <div
                    v-for="(item1, index1) in item.PropValueList"
                    :key="index1 + 1"
                    class="comdity-detail-left-checkbox"
                  >
                    <el-checkbox
                      v-model="item1.checked"
                      :label="item1.FpropValue"
                      @change="testCheck(item, item1.FpropValue)"
                    />
                  </div>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
          <!--同类热销-->
          <div class="similar-goods">
            <nav class="comdity-detail-aside-nav">
              <span><div class="diamond" />同类热销</span>
            </nav>
            <div v-for="(t,i) in recommendList.PageList" :key="i" class="similar-goods-info">
              <img v-if="t.FCover" :src="t.FCover" alt="">
              <img v-else src="../../../assets/images/no-pic.jpg">
              <p>
                <span @click="onTapToDetail(t,true)">{{ t.FStockName }}</span>
                <span>￥{{ t.fStockPrice ?_stockPrice(t.fStockPrice,t.FTPriceDecimal)  : '0.00' }}</span>
              </p>
            </div>
          </div>
          <!--推荐商品-->
        </aside>
        <!-- 下放右侧同系列产品、商品详情、评价 -->
        <div class="comdity-detail-right">

          <!-- 商品详情和评价 -->
          <div class="goods-introduce">
            <div class="detail-nav">
              <div :class="activeName == '0' ? 'select-nav' : 'nav'" @click="getIntroduce('0')">
                <span>商品介绍</span>
              </div>
              <div :class="activeName == '1' ? 'select-nav' : 'nav'" @click="changeActiveName('1')">
                <span>同系列产品</span>
              </div>
              <div v-if="activeName == '1'" class="searchIpt">
                <el-input v-model="dataList.jsonobj.fStockName" placeholder="请输入商品名称">
                  <i slot="prefix" class="el-input__icon el-icon-search" />
                  <template slot="append"><div class="searchBtn" @click="onSearch">查询</div></template>
                </el-input>
              </div>
            </div>
            <div v-if="activeName == '0'" class="introduce-info">
              <div class="item">
                <div class="title">品牌名称：</div>
                <span>{{ introduceData.MarkName }}</span>
              </div>
              <div class="item">
                <div class="title">厂家型号：</div>
                <span>{{ detailsList ? detailsList.FSpecification : "" }}</span>
              </div>
              <div class="item">
                <div class="title">厂家货号：</div>
                <span>{{ detailsList ? detailsList.FFactoryCode : '' }}</span>
              </div>
              <div class="item">
                <div class="title">订货编码：</div>
                <span>{{ detailsList ? detailsList.FShortCode.slice(0, 9) : "" }}</span>
              </div>
              <div class="item">
                <div class="title">起订量：</div>
                <span>{{ detailsList ? detailsList.FOrderQuantity : "" }}</span>
              </div>
              <div class="item">
                <div class="title">包装量：</div>
                <span>{{ detailsList ? detailsList.FMinPackQuanty : "" }}</span>
              </div>
              <!-- <div v-for="(item, index) in introduceData.StockPropList" :key="index" class="item">
                <div class="title">{{ item.FName }}</div>
                <span>{{ item.FValue }}</span>
              </div> -->
            </div>

            <div v-if="activeName == '0'" class="goods-html" v-html="introduceData.FContent" />
            <div v-if="activeName == '0'" class="goods-html" v-html="introduceData.FPlatStockFcontent" />

            <!-- 同系列产品 -->
            <div v-if="activeName == '1'" class="same-goods-list">
              <el-table
                :data="sameGoodsList"
                :fit="true"
                :header-cell-style="{ textAlign: 'left' }"
                :cell-style="{ textAlign: 'left' }"
              >
                <el-table-column prop="name" label="图例" width="120">
                  <template slot-scope="scope">
                    <el-image
                      style="width: 100px; height: 100px"
                      :src="scope.row.FCover"
                      :preview-src-list="scope.row.FCover ? [scope.row.FCover] : []"
                    >
                      <div slot="error" class="image-slot">
                        <img class="goods-info-image" :src="dataimg" alt="">
                      </div>
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="商品信息" width="300">
                  <template slot-scope="scope">
                    <div class="stock-info" @click="onTapToDetail(scope.row)">
                      {{ scope.row.FStockName }}
                    </div>
                    <div class="codeBox">
                      订货编码：
                      <span class="copyCode" @click.stop="copyCode(scope.row.FShortCode,0)">
                        <span class="codeInfo">{{ scope.row.FShortCode }}</span>
                        <i class="el-icon-document-copy" />
                      </span>
                    </div>
                    <div class="codeBox">
                      <template v-if="scope.row.FDemandStcokCode">
                        需方编码：
                        <span
                          class="copyCode"
                          @click.stop="copyCode(scope.row.FDemandStcokCode,1)"
                        >
                          <el-tooltip
                            class="item"
                            effect="dark"
                            :content="scope.row.FDemandStcokCode"
                            placement="top-start"
                          >
                            <span class="codeInfo">{{ scope.row.FDemandStcokCode }}</span>
                          </el-tooltip>
                          <i class="el-icon-document-copy" />
                        </span>
                      </template>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="FPrice" label="价格/单位">
                  <template slot-scope="scope">
                    <span v-if="FPriceShow" class="goods-info-price">
                      <span style="font-size:12px;font-weight:600;">￥</span>
                      <span
                        style="font-weight:600;"
                        v-html="stockPrice(scope.row.fStockPrice,20,scope.row.FTPriceDecimal)"
                      />
                      <span
                        v-if="scope.row.FMeasurement"
                        style="color:#333333;"
                      >/{{ scope.row.FMeasurement }}</span>

                    </span>
                    <span v-else id="noShowPrice">
                      <span style="margin:0;">￥</span>价格不可见
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="address" label="订购数量" width="200">
                  <template slot-scope="scope">
                    <el-input-number
                      v-model="scope.row.goodNumber"
                      size="small"
                      :min="1"
                      :max="99999"
                    />
                  </template>
                </el-table-column>
                <el-table-column prop="address" label="操作">
                  <template slot-scope="scope">
                    <el-button
                      v-if="scope.row.IsDirectoryPool"
                      class="goods-info-addcart-button"
                      @click="addShoppingCart(scope.row,scope.row.goodNumber)"
                    >
                      <svg-icon icon-class="cart" />
                      加入购物车
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                :page-size="pageSize"
                :total="total"
                background
                class="pagination"
                :current-page.sync="pageNo"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </div>

            <!-- 评价分 -->
            <!-- <div v-if="activeName == '1'" class="goods-rate">
              <div class="big-rate">
                <div class="left-rate">
                  <div class="big-num">
                    {{
                      Number(
                        commentData.ComprehensiveScore
                          ? commentData.ComprehensiveScore
                          : 0
                      ).toFixed(2)
                    }}
                  </div>
                  <div class="text">综合评分</div>
                </div>
                <div class="right-rate">
                  <div class="rate-item">
                    物流评分
                    <span>{{
                      Number(
                        commentData.FTransportScore
                          ? commentData.FTransportScore
                          : 0
                      ).toFixed(2)
                    }}</span>
                  </div>
                  <div class="rate-item">
                    质量评分
                    <span>{{
                      Number(
                        commentData.FQualityScore
                          ? commentData.FQualityScore
                          : 0
                      ).toFixed(2)
                    }}</span>
                  </div>
                  <div class="rate-item">
                    服务评分
                    <span>{{
                      Number(
                        commentData.FServiceScore
                          ? commentData.FServiceScore
                          : 0
                      ).toFixed(2)
                    }}</span>
                  </div>
                </div>
              </div>

              <div class="select-radio">
                <div class="radio">
                  <el-radio-group v-model="radio">
                    <el-radio
                      v-for="(item, index) in radioList"
                      :key="index"
                      :label="item.value"
                      @change="redioClick(item)"
                    >{{ item.label }}</el-radio>
                  </el-radio-group>
                </div>
                <div class="select">
                  <span>排序</span>
                  <el-select
                    v-model="selectValue"
                    placeholder="请选择"
                    @change="applicantTypes"
                  >
                    <el-option
                      v-for="(item, index) in selectOptions"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </div>
              </div>
              <div>
                <div
                  v-for="(item, index) in commentTable"
                  :key="index"
                  class="goods-evaluate"
                >
                  <div class="eva-userAvatar">
                    <img
                      class="avatar"
                      src="@/assets/images/detail-img.png"
                      alt=""
                    >
                    <img class="vip" src="@/assets/images/vip.png" alt="">
                    <span>黄金会员</span>
                  </div>
                  <div class="eva-rightInfo">
                    <div class="userName">{{ item.FNickName }}</div>
                    <div class="eva-rate">
                      <div class="eva-item">
                        <span>物流评分</span>
                        <el-rate
                          v-model="item.FTransportStar"
                          disabled
                          el-rate
                          :colors="colors"
                        />
                      </div>
                      <div class="eva-item">
                        <span>质量评分</span>
                        <el-rate
                          v-model="item.FQualityStar"
                          disabled
                          el-rate
                          :colors="colors"
                        />
                      </div>
                      <div class="eva-item">
                        <span>服务评分</span>
                        <el-rate
                          v-model="item.FServiceStar"
                          disabled
                          el-rate
                          :colors="colors"
                        />
                      </div>
                    </div>
                    <div class="eva-content">{{ item.FAppraiseComment }}</div>
                    <div class="eva-time">{{ item.FAppraiseDate }}</div>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 主要内容END -->
  </div>
</template>
<script>
import {
  mapActions
} from 'vuex'
import {
  getImgTil,
  CollectionData,
  shopRecommend,
  getShopTable,
  getShopIntroduce,
  getcomment,
  getcommentTable,
  getparameter,
  addTocart,
  getByNow
} from '@/api/shopDetails'
import PicZoom from 'vue-piczoom'
import {
  regionData,
  CodeToText
} from 'element-china-area-data'
import qs from 'qs'
export default {
  components: {
    PicZoom
  },
  /**
         * keep-alive生命周期取消掉用，取消改变背景颜色
         */
  filters: {
    delivery(val) {
      if (val && val.length > 6) {
        return val.slice(0, 6)
      } else {
        return val
      }
    }
  },
  data() {
    return {
      fpurchaseMode: null,
      nodata: '',
      total: null,
      flagData: true,
      radioList: [{
        value: -1,
        label: '全部'
      },
      {
        value: 0,
        label: '好评'
      },
      {
        value: 1,
        label: '中评'
      },
      {
        value: 2,
        label: '差评'
      }
      ],
      currentPage4: 1,
      dis: false, // 控制“加入购物车按钮是否可用”
      productID: '', // 商品id
      productDetails: '', // 商品详细信息
      productPicture: '', // 商品图片
      topStyle: {
        transform: ''
      },
      num: 0,
      rank: 4.5, // 供方等级
      FAreaId: '', // 配送地址
      goodsNum: 1,
      colors: ['#EF8843', '#EF8843', '#EF8843'],
      numImage: 0, // 商品下方选择图片
      radio: -1, // 评价选择
      evaRank: 5, // 评价评分
      options: regionData, // 二级联动不带全部
      selectedOptions: [], // 城市选择
      opends: [], // 规格参数list默认展开的项
      SpecificationParamList: [],
      selectOptions: [{
        value: 0,
        label: '按时间正序'
      },
      {
        value: 1,
        label: '按时间倒序'
      }
      ],
      currentImage: '', // 默认当前轮播图
      selectValue: 0, // 排序 按时间
      sameGoodsList: [],
      ImageList: [],
      dataimg: require('@/assets/images/no-pic.jpg'),
      recommendList: [],
      r_img: {},
      topShow: false,
      rShow: false,
      activeName: '0',
      detailsList: {
        FFactoryCode: '',
        FDemandStcokCode: '',
        fDeliveryInfo: '',
        webareaFLevelName: ''
      },
      pageNo: 1,
      pageSize: 10,
      dataList: {
        mallstoreStockId: null,
        jsonobj: {
          stdStockPropList: [],
          fStockName: ''
        }
      },
      introduceData: {},
      commentData: {},
      commentTable: [],
      paramsData: [],
      fIsApproval: false,
      contacts: [],
      FPriceShow: 0
    }
  },
  watch: {
    '$route.query': {
      deep: true,
      handler(val) {
        this.$nextTick(() => {
          this.getparamsData()
          this.getShopRecommend()
          this.pageNo = 1
          this.getDataTable()
        })
      }
    },
    // 监听商品id的变化，请求后端获取商品数据
    productID: function(val) {
      this.getDetails(val)
      this.getDetailsPicture(val)
    },
    'dataList.mallstoreStockId': {
      handler(val, olval) {
        if (val != olval) {
          this.getDetails()
          this.getShopRecommend()
          this.getDataTable()
          this.getIntroduce(0)
          this.getparamsData()
        }
      }
    }
  },
  deactivated() {
    // document.getElementById("storeApp").removeAttribute("style");
  },
  created() {
    this.SpecificationParamList.forEach((item) => {
      this.opends.push(item.index)
    })
    const userInfor = localStorage.getItem('userInfo')
    userInfor && (this.FPriceShow = JSON.parse(userInfor).FPriceShow)
    userInfor && (this.fpurchaseMode = JSON.parse(userInfor).fpurchaseMode)
    // const UserInfo = JSON.parse(localStorage.getItem('userInfo'))
    // this.fpurchaseMode = UserInfo.fpurchaseMode
  },
  mounted() {
    document
      .getElementById('storeApp')
      .setAttribute('style', 'background-color:#ffffff;')
    const data = this.$route.query.mallstorestockFId
    if (data) {
      this.dataList.mallstoreStockId = data
    }
  },
  methods: {
    ...mapActions(['unshiftShoppingCart', 'addShoppingCartNum']),
    onSearch() {
      this.pageNo = 1
      this.getDataTable()
    },
    _stockPrice(val,FTPriceDecimal) {
      let price = val||0;
      console.log(val)
      if(FTPriceDecimal!=undefined||FTPriceDecimal!=null)price = val.toFixed(FTPriceDecimal);
      else price=val.toFixed(2);
      price=String(parseFloat(price||0));
      return price
    },
    onTapToDetail(val, n) {
      const MallStoreStockId = n ? val.MallstoreStockId : val.MallStoreStockId
      const FMallStoreID = val.FMallStoreID
      const url =
                    `${location.protocol}//${location.host}/#/store/details?mallstorestockFId=${MallStoreStockId}&shopid=${FMallStoreID}`
      open(url)
    },
    stockPrice(val, size,FTPriceDecimal) {
      let price = val||0;
      console.log(val)
      if(FTPriceDecimal!=undefined||FTPriceDecimal!=null)price = val.toFixed(FTPriceDecimal);
      else price=val.toFixed(2);
      price=String(parseFloat(price||0));
      if(price.indexOf(".")>-1){
        const arr = price.split('.')
        return `<span style='font-size:${size}px;'>${arr[0]}</span>.${arr[1]}`
  
      }else{
        return `<span style='font-size:${size}px;'>${price}</span>`
  
      }
    },
    copyCode(val, n) {
      const str = n ? '需方编码' : '订货编码'
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', val)
      input.setAttribute('create', 1)
      input.select()
      document.execCommand('Copy')
      this.$notify({
        message: `${str}已成功复制`,
        type: 'success',
        position: 'bottom-left',
        duration: 1000
      })
      var list = document.getElementsByTagName('input')
      var inputList = Array.prototype.slice.call(list)
      inputList.forEach((item) => {
        if (item.getAttribute('create')) document.body.removeChild(item)
      })
    },
    htmlValue(val) {
      const key = this.search
      if (key.length > 0) {
        return val.replace(
          new RegExp(key, 'g'),
          "<span style='color: #EC212D;'>" + key + '</span>'
        )
      }
      return val
    },
    assderFilt(item) {
      const asderr = item.split('\\')
      let index = asderr.find((items) => {
        if (items) {
          return String(items).search('市') > -1
        } else {
          return false
        }
      })
      if (!index) {
        index = asderr[asderr.length - 1]
      }
      return index
    },
    maxlang(str, maxleng) {
      if (str == null) {
        return ''
      }
      str = String(str)
      if (str.length > maxleng) {
        return `<i style='font-style: normal;' title='${str}'>${str.slice(0, maxleng) + '...'}<i/>`
      } else {
        return str.slice(0, maxleng)
      }
    },
    shopItemClick(val) {
      this.dataList.mallstoreStockId = val.MallstoreStockId
      const routeUrl = this.$router.resolve({
        path: '/store/details',
        redirect: '',
        query: {
          mallstorestockFId: val.MallstoreStockId,
          shopid: val.FMallStoreID
        }
      })
      window.open(routeUrl.href, '_blank') // 新标签页打开商品详情
    },
    FixedTo(num) {
      const str = !isNaN(Number(num)) ? Number(num).toFixed(3) : '0.00'
      const index = str.indexOf('.')
      return str.slice(0, index + 3)
    },
    stopF5Refresh() {
      // 禁止鼠标右键菜单
      // document.oncontextmenu = function(e) {
      //   return false
      // }
      // 阻止后退的所有动作，包括 键盘、鼠标手势等产生的后退动作。
      // history.pushState(null, null, window.location.href)
      // window.addEventListener('popstate', function() {
      //   history.pushState(null, null, window.location.href)
      // })
    },
    // 去跳转到
    gopurchase(val) {
      if (this.fpurchaseMode) return
      this.$router.push({
        path: '/submitOrder',
        query: {
          id: val.MallstoreStockId,
          num: this.goodsNum,
          source: 1
        }
      })
    },

    getparamsData() {
      const FSearchType = Number(!this.$parent.$parent.$parent.$refs.headerSearch.isShoping)
      getparameter(this.dataList.mallstoreStockId, FSearchType).then((res) => {
        this.paramsData = res.data
      })
    },
    applicantTypes(val) {
      this.selectValue = val
      this.pageNo = 1
      //   this.commTable()
      this.currentPage4 = 1
    },
    redioClick(item) {
      this.radio = item.value
      this.pageNo = 1
      //   this.commTable()
      this.currentPage4 = 1
    },

    handleSizeChange(val) {
      this.pageSize = val
      this.getDataTable()
    //   this.commTable()
    },
    handleCurrentChange(val) {
      this.pageNo = val
      this.getDataTable()
    //   this.commTable()
    },

    commTable() {
      getcommentTable({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        mallstoreStockId: this.dataList.mallstoreStockId,
        queryType: this.radio,
        sortType: this.selectValue
      }).then((res) => {
        if (res.code == 200) {
          this.commentTable = res.data.records
          this.total = res.data.total
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 切换介绍和评价
    changeActiveName(item) {
      this.activeName = item
    //   getcomment(this.dataList.mallstoreStockId).then((res) => {
    //     if (res.code == 200) {
    //       this.commentData = res.data
    //       this.commTable()
    //     } else {
    //       this.$message.error(res.message)
    //     }
    //   })
    },
    // 商品介绍数据
    getIntroduce(item) {
      this.activeName = item
      getShopIntroduce(this.dataList.mallstoreStockId).then((res) => {
        if (res.code == 200) {
          this.introduceData = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    // 点击多选获取数据
    testCheck(item, itemName) {
      this.$set(this, 'pageNo', 1)
      this.activeName = 1
      item.PropValueList.map((it) => {
        if (it.checked == true) {
          this.dataList.jsonobj.stdStockPropList.push({
            fPropName: item.FpropName,
            fPropValue: itemName
          })
        } else {
          for (
            let index = 0; index < this.dataList.jsonobj.stdStockPropList.length; index++
          ) {
            if (
              it.FpropValue ==
                                this.dataList.jsonobj.stdStockPropList[index].fPropValue
            ) {
              this.dataList.jsonobj.stdStockPropList.splice(index, 1)
            }
          }
        }
      })
      this.getDataTable()
    },
    // 获取分类点击数据
    getDataTable() {
      const arr = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        mallstoreStockId: this.dataList.mallstoreStockId,
        jsonobj: JSON.stringify(this.dataList.jsonobj),
        FSearchType: Number(!this.$parent.$parent.$parent.$refs.headerSearch.isShoping)
      }
      getShopTable(qs.stringify(arr)).then((res) => {
        if (res.code == 200) {
          this.sameGoodsList = res.data.PageList.records || []
          this.total = res.data.PageList.total
          if (res.msg == '抱歉该商品已下架,请刷新页面重试！') {
            this.$message.error(res.msg)
            return
          }
          this.sameGoodsList.map((item) => {
            item.FShortCode && (item.FShortCode = item.FShortCode.slice(0, 9))
            this.$set(item, 'goodNumber', 1)
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取店铺推荐数据
    getShopRecommend() {
      const FSearchType = Number(!this.$parent.$parent.$parent.$refs.headerSearch.isShoping)
      shopRecommend(this.dataList.mallstoreStockId, FSearchType).then((res) => {
        if (res.result == true) {
          this.recommendList = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    // 收藏商品
    Collection(val) {
      let opval = ''
      if (val == 1) {
        opval = 1
      } else {
        opval = 3
      }
      CollectionData(this.dataList.mallstoreStockId, 9, opval).then((res) => {
        if (res.code == 200) {
          if (res.msg == '取消收藏成功') {
            this.$message({
              message: res.msg,
              type: 'success'
            })
            this.flagData = true
          } else {
            this.$message({
              message: res.msg,
              type: 'success'
            })
            this.flagData = false
          }
        } else {
          this.$message(res.msg)
        }
      })
    },

    // 获取商品详细信息
    getDetails(val) {
      getImgTil(this.dataList.mallstoreStockId).then((res) => {
        if (res.result == false) {
          this.$message.error(res.msg)
          this.$router.push({
            path: '/store'
          })
          return
        }
        if (res.data.FIsCollect == 0) {
          this.flagData = true
        } else {
          this.flagData = false
        }
        if (res.code == 200) {
          this.fIsApproval = res.data.fIsApproval
          this.detailsList = res.data
          let min = '0.'
          for (let i = 1; i < this.detailsList.FQuantyDecimal; i++) {
            min += '0'
          }
          this.detailsList['min'] = Number(min + '1')
          this.rank = res.data.ProviderLevel
          this.ImageList = res.data.RotationmapList
          this.currentImage = res.data.RotationmapList.length ? res.data.RotationmapList[0]
            .RotationMapUrl : ''
          this.$parent.$parent.$parent.classList = res.data.FStdClassList
          this.$parent.$parent.$parent.stockName = res.data.FStockName
          this.contacts = res.data.FMallStoreList
        } else {
          this.detailsList = []
          this.rank = ''
          this.ImageList = []
          this.currentImage = ''
          this.$message.error(res.msg)
        }
      })
    },
    // 获取商品图片
    getDetailsPicture(val) {
      // this.$axios
      //   .post('/api/product/getDetailsPicture', {
      //     productID: val
      //   })
      //   .then(res => {
      //     this.productPicture = res.data.ProductPicture
      //   })
      //   .catch(err => {
      //     return Promise.reject(err)
      //   })
    },
    /**
             * 清空规格参数选中
             */
    clearCheckbox() {},
    // 加入购物车
    addShoppingCart(val, n, b) {
      const arr = {
        jsonobj: JSON.stringify({
          shoppingCartList: [{
            fstockName: val.FStockName,
            fmallstoreStockId: b ? this.dataList.mallstoreStockId : val.MallStoreStockId,
            fQuanty: n
          }]
        })
      }
      addTocart(qs.stringify(arr)).then((res) => {
        if (res.result) {
          this.$parent.$parent.$parent.$refs.headerSearch.getComput()
          this.$parent.$parent.$parent.$refs.rightNav.getComput()
          this.$message({
            message: res.msg,
            type: 'success'
          })
        } else {
          this.$message({
            message: res.msg,
            type: 'warning'
          })
        }
      })
    },
    addCollect() {},
    /**
             * 清空规格参数
             */
    clearParamList() {
      this.paramsData.forEach((item) => {
        item.PropValueList.forEach((item1) => {
          item1.checked = false
          this.dataList.jsonobj.stdStockPropList = []
        })
      })
      this.pageNo = 1
      this.getDataTable()
    },
    prev() {
      if (this.num < 0) {
        this.num += 1
      }
    },
    next() {
      if (this.num > -(this.recommendList.PageList.length - 1 + this.num)) {
        this.num -= 1
      }
    },
    prevImage() {
      if (this.numImage < 0) {
        this.numImage += 1
      }
    },
    nextImage() {
      if (this.numImage > -(this.ImageList.length - 1 + this.numImage)) {
        this.numImage -= 1
      }
    },
    selectCity() {
      for (let i = 0; i < this.selectedOptions.length; i++) {
        this.FAreaId += CodeToText[this.selectedOptions[i]]
      }
    },
    // 切换轮播图
    selectGoodsImage(item) {
      this.currentImage = item.RotationMapUrl
    },

    handleOpen() {},
    handleClose() {},
    // 选择商品数量
    handleChange(value) {},
    // 鼠标进入原图空间函数
    enterHandler() {
      // 层罩及放大空间的显示
      this.topShow = true
      this.rShow = true
    },
    // 鼠标移动函数
    moveHandler(event) {
      // 鼠标的坐标位置
      const x = event.offsetX
      const y = event.offsetY
      // 层罩的左上角坐标位置，并对其进行限制：无法超出原图区域左上角
      let topX = x - 100 < 0 ? 0 : x - 100
      let topY = y - 100 < 0 ? 0 : y - 100
      // 对层罩位置再一次限制，保证层罩只能在原图区域空间内
      if (topX > 200) {
        topX = 200
      }
      if (topY > 200) {
        topY = 200
      }
      // 通过 transform 进行移动控制
      this.topStyle.transform = `translate(${topX}px,${topY}px)`
      this.r_img.transform = `translate(-${0 * topX}px,-${0 * topY}px)`
    },
    // 鼠标移出函数
    outHandler() {
      // 控制层罩与放大空间的隐藏
      this.topShow = false
      this.rShow = false
    }
  }
}
</script>
<style lang="scss" scoped>
    #details #noShowPrice {
        display: inline-block;
        text-align: center;
        padding: 0 5px;
        font-size: 14px;
        color: #ec2631;
        width: 100px;
        margin: 0 auto;
        font-weight: 400;

        span {
            font-size: 12px;
        }
    }

    .isDirectoryPool {
        min-width: 90px;
        height: 24px;
        line-height: 24px;
        padding-left: 10px;
        background: #fbd2d5;
        font-size: 14px;
        color: #EC212D;
        font-weight: bold;
    }

    /**头部面包屑 */
    .breadcrumb {
        width: 100%;
        height: 46px;
        line-height: 46px;
        background-color: #f5f5f5;
        display: block;
        position: absolute;
        left: 0;
    }

    .breadcrumb-box {
        width: 1200px;
        min-width: 1200px;
        margin: 0 auto;
    }

    .detail-goods-info {
        width: 100%;
        display: flex;
        margin-bottom: 10px;
        height: 566px;
        background: #fff;
        padding: 22px 46px 10px 12px;
        // margin-top:46px;
    }

    .goods-image {
        position: relative;
        width: 450px;

        /* 原图的显示 */
        .leftImg {
            width: 450px;
            height: 450px;
            display: inline-block;
            position: relative;
        }

        /* 原图的容器 */
        .left {
            width: 450px;
            height: 450px;
            position: relative;
        }

        .goodsImage-list {
            display: flex;
            flex-direction: row;
            position: relative;
            width: 100%;
            height: 80px;
            overflow: hidden;
            margin-top: 10px;

            ul {
                display: flex;
                padding: 0 36px;
            }

            li {
                height: 72px;
                background: #ffffff;
                // padding: 9px;
                display: flex;

                img {
                    width: 72px;
                    height: 72px;
                    margin-right: 10px;
                }

                img:hover {
                    width: 72px;
                    height: 72px;
                    margin-right: 10px;
                    border: 1px solid red;
                }
            }

            .goods-button {
                height: 72px;
                width: 26px;
                line-height: 72px;
                z-index: 10;
                background: #fff;
                z-index: 999;
                border: 1px solid #f5f5f5;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .goods-button:hover {
                height: 72px;
                width: 26px;
                line-height: 72px;
                z-index: 10;
                background: #dcdcdc;
                z-index: 999;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .goods-button:nth-child(1) {
                position: absolute;
                left: 0;
            }

            .goods-button:last-child {
                position: absolute;
                right: 0;
            }
        }
    }

    .goods-operation {
        caret-color: transparent;
        width: 100%;
        height: 66px;
        padding-left: 15px;
        display: flex;
        align-items: center;
        //   justify-content: space-between;
        font-size: 16px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        ;
        font-weight: 400;
        color: #666;

        >div {
            line-height: 22px;
            width: 326px;
            color: #EC212D;

            .collection {
                cursor: pointer;
                width: 75px;
                display: flex;
            }

            .svg-icon {
                margin-right: 8px;
            }

            .writeText {
                color: #333;
            }

            .iconHover {
                display: none;
            }
        }

        //   >div:hover {
        //       background: #EC212D;
        //       border-color: #EC212D;
        //       color: #fff;
        //       .writeText {
        //           color: #fff;
        //       }
        //       .iconEnter {
        //           display: none;
        //       }
        //       .iconHover {
        //           display: inline-block;
        //       }
        //   }
        span {
            display: flex;
            align-items: center;
        }
    }

    /**价格区域 */
    .content-price {
        position: relative;
        width: 100%;
        height: 66px;
        display: flex;
        align-items: center;
        border-radius: 2px;
        box-sizing: border-box;
        padding: 20px 0;
        font-size: 16px;
        border-bottom: 1px dashed rgba(0, 0, 0, 0.1);

        .noPool {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 36px;
            line-height: 36px;
            background: #FBD2D5;
            font-size: 16px;
            color: #ec2631;
            padding-left: 14px;
            font-weight: bold;
            font-family: Microsoft YaHei;
        }

        .old-price {
            font-size: 16px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            ;
            font-weight: 400;
            color: #333333;
            display: flex;
            min-width: 214px;
            margin-top: 8px;
            flex: 1;

            div {
                // text-indent:17px;
                letter-spacing: 6px;
                font-size: 14px;
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                ;
                font-weight: 400;
                color: #999999;
                // width: 70px;
            }

            .price-black {
                text-decoration: line-through;
                margin: 0 6px 0 6px;
            }
        }

        .my-price {
            font-size: 16px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            ;
            font-weight: bold;
            color: #333;
            flex: 1;
            min-width: 214px;

            .big-red {
                font-size: 24px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #ec2631;
            }

            .big-red::before {
                content: "¥";
                width: 7px;
                height: 9px;
                font-size: 14px;
                font-weight: bold;
                color: #ec2631;
                line-height: 24px;
                margin: 0 5px 0 5px;
            }

            .big-red::after {
                content: "";
                font-weight: bold;
                color: #ec2631;
                font-size: 15px;
                margin-right: 10px;
            }
        }
    }

    .goods-manufactor {
        width: 100%;
        height: 144px;
        border-bottom: 1px dashed rgba($color: #000000, $alpha: 0.1);
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        box-sizing: border-box;
        padding: 20px 0 15px 15px;
        font-size: 14px;

        .el-icon-document-copy {
            position: relative;
            top: 3px;
        }

        .itemLength {
            display: inline-block;
            max-width: 152px !important;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .titleLength {
            float: left;
        }

        .colordata {
            display: inline-block;
            width: 80px;
            text-align-last: justify;
            text-align: justify;
            color: #666 !important;
            margin-right: 15px;
        }

        .item {
            word-wrap: break-word;
            word-break: normal;
            width: 50%;
            height: 40px;
            font-size: 16px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            ;
            font-weight: 400;
            padding: 0px 0px 20px 0px;
            color: #999999;

            span {
                color: #333333;
            }

            .tag {
                width: auto;
                display: inline-block;
                height: 22px;
                line-height: 22px;
                background: #F5783C;
                padding: 0 5px;
                border-radius: 2px;
                font-size: 12px;
                color: #fff;
                text-align: center;
            }

            .shipment-place {
                display: inline-block;
                text-align: center;
                font-size: 12px;
                min-width: 64px;
                width: auto;
                height: 22px;
                line-height: 22px;
                background: rgba(245, 120, 60, 0.14);
                border-radius: 4px;
                border: 1px solid #F5783C;
                color: #F5783C;
            }
        }
    }

    .goods-distribution {
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding: 15px;

        .item {
            display: flex;
            align-items: center;
            height: 50px;
            margin-bottom: 20px;
            font-size: 14px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            ;
            font-weight: 400;
            color: #999999;
            position: relative;

            .icon {
                position: absolute;
                left: 65px;
                z-index: 99;
            }
        }

        .deliver-goods {
            margin-left: 60px;
            display: flex;
            align-items: center;
        }

        .deliver-goods span:first-child {
            width: 40px;
            height: 20px;
            background: #ffffff;
            border: 1px solid #2475ea;
            border-radius: 4px;
            font-size: 12px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            ;
            font-weight: 400;
            color: #2475ea;
            margin-right: 11px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .deliver-goods span:last-child {
            font-size: 12px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            ;
            font-weight: 400;
            color: #999999;
            margin-left: 30px;
        }
    }

    .goods-supplier {
        width: 100%;
        height: 84px;
        border: 1px solid #ffedc8;
        background: linear-gradient(0deg, #ffffff 0%, #fffaf0 100%);
        border-radius: 2px;
        box-sizing: border-box;
        padding: 15px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;

        .item {
            width: 30%;
            height: 30px;
            font-size: 14px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            ;
            font-weight: 400;
            color: #999999;
            display: flex;
            align-items: center;

            span {
                color: #ff812c;
            }
        }
    }

    .goods-payButton {
        width: 100%;
        border-top: 1px dashed rgba($color: #000000, $alpha: 0.1);
        box-sizing: border-box;
        padding-top: 40px;
        display: flex;
        align-items: center;

        .pay-button {
            width: 138px;
            height: 42px;
            background: #ec212d;
            border-radius: 4px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 16px 0 32px;

            .buy-img {
                margin-right: 10px;
            }
        }

        .no-pay {
            cursor: not-allowed !important;
            background: #f5f7fa;
            color: #c0c4cc;
            border: 1px solid #e4e7ed;
        }

        .addCart {
            width: 156px;
            height: 42px;
            background: #ffffff;
            border: 1px solid #ec212d;
            border-radius: 4px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ec212d;
        }
    }

    .goods-payButton div:first-child {
        width: 170px;
    }

    /**店铺推荐开发 */
    .shop-recommend {
        ul {
            display: flex;
            padding: 0 36px;
        }

        li {
            height: 116px;
            background: #ffffff;
            border: 1px solid #d2d2d2;
            padding: 9px;
            margin-right: 13px;
            flex: 0 0 272px;
            display: flex;
        }

        .shop-list {
            display: flex;
            flex-direction: row;
            position: relative;
            overflow: hidden;
        }

        .shop-button {
            height: 116px;
            width: 26px;
            line-height: 116px;
            z-index: 10;
            background: #fff;
            border: 1px solid #f5f5f5;
            z-index: 999;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .shop-button:hover {
            height: 116px;
            width: 26px;
            line-height: 116px;
            z-index: 10;
            background: #dcdcdc;
            z-index: 999;
        }

        .shop-button:nth-child(1) {
            position: absolute;
            left: 0;
        }

        .shop-button:last-child {
            position: absolute;
            right: 0;
        }

        img {
            width: 96px;
            height: 96px;
        }

        .shop-title {
            width: 100%;
            height: 46px;
            line-height: 46px;
            background: #f5f5f5;
            border: 1px solid #d2d2d2;
            border-radius: 2px 2px 0px 0px;
            font-size: 18px;
            color: #333;
            font-weight: 500;
            text-align: left;
            padding-left: 21px;
            margin-bottom: 10px;
        }

        .shop-info {
            flex-direction: column;
            margin-left: 11px;
            justify-content: space-between;
            font-size: 14px;

            .shop-info-name {
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                ;
                font-weight: 400;
                color: #333333;
                font-size: 16px;
                margin-bottom: 30px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2; //保留多少行
                overflow: hidden;
            }

            .shop-info-price {
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #ec212d;
                margin-right: 20px;
            }
        }
    }

    /**商品详情下放介绍 */
    .comdity-detail {
        margin-top: 30px;
        //   background: #fff;
        display: flex;

        .diamond {
            display: inline-block;
            width: 6px;
            height: 6px;
            background: #EC212D;
            margin-right: 8px;
            position: relative;
            top: -2px;
        }

        .comdity-detail-left {
            caret-color: transparent;
            width: 260px;
            min-width: 260px;

            .comdity-detail-left-checkbox {
                width: 50%;
            }
        }

        .comdity-detail-aside-nav {
            height: 46px;
            background: #fff;
            border-bottom: none;
            border-radius: 2px 2px 0px 0px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
            font-size: 14px;
            color: #333;

            button {
                font-size: 12px;
                width: 62px;
                height: 22px;
                line-height: 22px;
                text-align: center;
                border: 1px solid #CCCCCC;
                border-radius: 4px;
                color: #666666;
                padding: 0;
            }

            button:hover {
                background: #ec212d;
                border-color: #ec212d;
                color: #fff;
            }
        }

        .similar-goods {
            display: flex;
            flex-direction: column;
            margin-top: 19px;

            .comdity-detail-aside-nav {
                border: none;
                border-bottom: 1px solid #d2d2d2;
            }

            .similar-goods-info {
                background: #fff;
                display: flex;
                flex-direction: row;
                padding: 10px;
                position: relative;
                border-bottom: 1px dashed #d2d2d2;

                img {
                    width: 72px;
                    height: 72px;
                    min-width: 72px;
                }

                p {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    margin-left: 8px;
                    font-size: 12px;

                    span:nth-child(1) {
                        cursor: pointer;
                        display: -webkit-box;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        word-break: break-all;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 3;
                        color: #333333;
                    }

                    span:nth-child(1):hover {
                        color: #ec212d;
                    }

                    span:last-child {
                        color: #ec212d;
                    }
                }
            }

            .similar-goods-info:last-child {
                border-bottom: none;
            }

            // .similar-goods-info::after{
            //   content: '';
            //   position: absolute;
            //   width: 90%;
            //   top: 0;
            //   border-bottom: 1px dashed #D2D2D2;
            // }
        }

        /**右侧 */
        .comdity-detail-right {
            // width: 100%;
            width: calc(100% - 260px - 20px);
            margin-left: 20px;

            .same-goods-list {
                width: 100%;

                .codeBox {
                    display: flex;
                    font-size: 12px;
                    color: #666;
                    min-height: 21px;
                    line-height: 21px;

                    .copyCode {
                        display: flex;
                        line-height: 21px;
                        cursor: pointer;
                    }

                    i {
                        line-height: 21px;
                        margin-left: 6px;
                    }

                    .codeInfo {
                        display: inline-block;
                        max-width: 134px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        -o-text-overflow: ellipsis;
                    }
                }

                .stock-info {
                    flex: 1;
                    cursor: pointer;
                    font-size: 16px;
                    line-height: 22px;
                    height: 44px;
                    display: -webkit-box;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    word-break: break-all;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;

                    .self-support {
                        display: inline-block;
                        width: 35px;
                        height: 18px;
                        line-height: 18px;
                        text-align: center;
                        border-radius: 3px;
                        background: #ec2631;
                        color: #fff;
                        font-size: 12px;
                    }
                }

                .stock-info:hover {
                    color: #ec2631;
                }

                .comdity-detail-aside-nav {
                    border: none;
                    border-bottom: 1px solid #d2d2d2;
                }

                .goods-info {
                    display: flex;
                    flex-direction: row;

                    .goods-info-image {
                        width: 86px;
                        height: 86px;
                    }
                }

                .goods-info-text {
                    display: flex;
                    flex-direction: column;
                    margin-left: 10px;
                    text-align: left;
                    font-size: 16px;

                    .goods-info-text-name {
                        width: 223px;
                        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                        ;
                        font-weight: 400;
                        color: #333333;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }

                    .goods-info-text-shortcode,
                    .goods-info-text-model {
                        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                        ;
                        font-weight: 400;
                        color: #999999;
                    }
                }

                .goods-info-price {
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #ec212d;
                }

                .goods-info-addcart-button {
                    width: 109px;
                    height: 36px;
                    line-height: 36px;
                    padding: 0;
                    background: #ffffff;
                    color: #ec212d;
                    border: 1px solid #ec212d;
                    border-radius: 4px;
                }
            }

            .goods-introduce {
                width: 100%;
                background: #fff;
                .searchBtn {
                    cursor: pointer;
                }

                .introduce-info {
                    display: flex;
                    flex-wrap: wrap;
                    width: 840px;
                    padding: 10px 0;
                    margin: 0 40px;
                    border-bottom: 1px dashed #d2d2d2;

                    .item {
                        width: 33%;
                        display: flex;
                        font-size: 12px;
                        color: #333;
                        line-height: 30px;

                        .title {
                            width: 60px;
                            height: 30px;
                            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                            font-weight: 400;
                            color: #666;
                            text-align: right;
                            margin-right: 5px;
                        }
                        span {
                            display: inline-block;
                            width: 195px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }
                }

                .line {
                    width: 100%;
                    height: 10px;
                    background: #f5f5f5;
                    margin: 30px 0 0 0;
                }

                .goods-html {
                    width: 100%;
                    min-height: 100px;
                    box-sizing: border-box;
                    padding: 20px;
                    padding-bottom: 0px;
                }

                .goods-html ::v-deep img {
                    display: block;
                    max-width: 100% !important;
                    margin: 0 auto;
                }

                .big-rate {
                    width: 100%;
                    height: 160px;
                    border-bottom: 1px dashed rgba($color: #000000, $alpha: 0.1);
                    display: flex;
                    align-items: center;
                    justify-content: space-around;

                    .left-rate {
                        width: 40%;
                        height: 160px;
                        display: flex;
                        align-items: center;
                        flex-direction: column;
                        justify-content: center;

                        .big-num {
                            font-size: 46px;
                            font-family: Arial;
                            font-weight: 400;
                            font-style: italic;
                            color: #ff812c;
                        }

                        .text {
                            font-size: 16px;
                            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                            ;
                            font-weight: 400;
                            color: #333333;
                        }
                    }

                    .right-rate {
                        width: 40%;
                        height: 160px;
                        display: flex;
                        align-items: center;
                        flex-direction: column;
                        justify-content: center;

                        .rate-item {
                            height: 30px;
                            font-size: 16px;
                            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                            ;
                            font-weight: 400;
                            color: #333333;

                            span {
                                font-size: 18px;
                                font-family: Arial;
                                font-weight: 400;
                                font-style: italic;
                                color: #ff812c;
                                margin-left: 25px;
                            }
                        }
                    }
                }

                .detail-nav {
                    position: relative;
                    width: 100%;
                    height: 46px;
                    display: flex;
                    background: #fff;
                    align-items: center;
                    border-bottom: 1px solid #E2E2E2;

                    .nav {
                        caret-color: transparent;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;

                        span {
                            font-size: 14px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            color: #333;
                            // height: 40px;
                        }
                    }
                }

                .select-nav {
                    caret-color: transparent;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 46px;
                    cursor: pointer;
                    border-bottom: 1px solid #ec212d;

                    span {
                        font-size: 14px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #ec212d;
                        height: 47px;
                        line-height: 46px;

                    }
                }

                .select-nav:first-child {
                    width: 100px;
                    margin-right: 5px;
                    background: #fff;
                }

                .select-nav:nth-child(2) {
                    width: 100px;
                    background: #fff;
                    // border-left: 1px solid #d2d2d2;
                    // border-right: 1px solid #d2d2d2;
                }

                .nav:first-child {
                    width: 100px;
                    margin-right: 5px;
                }

                .nav:nth-child(2) {
                    width: 100px;
                }

                .select-radio {
                    width: 100%;
                    height: 70px;
                    border-bottom: 1px dashed rgba($color: #000000, $alpha: 0.1);
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    box-sizing: border-box;
                    padding: 0 10px;

                    .select {
                        span {
                            font-size: 14px;
                            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                            ;
                            font-weight: 400;
                            color: #999999;
                            margin-right: 11px;
                        }
                    }
                }

                .pagination {
                    background-color: #F3F3F3;
                    width: 100%;
                    height: 56px;
                    display: flex;
                    align-items: end;
                    justify-content: flex-end;
                    ::v-deep .el-pager {
                        .number {
                            border: 1px solid #DCDCDC;
                        }
                        .active {
                            border: 1px solid #EC212D;
                        }
                    }
                }

                .goods-evaluate {
                    width: 100%;
                    min-height: 100px;
                    display: flex;
                    box-sizing: border-box;
                    padding: 20px;
                    border-bottom: 1px dashed rgba($color: #000000, $alpha: 0.1);

                    .eva-userAvatar {
                        width: 55px;
                        min-height: 100px;
                        margin-right: 20px;
                        position: relative;

                        .avatar {
                            width: 50px;
                            height: 50px;
                            border-radius: 50%;
                        }

                        .vip {
                            width: 28px;
                            height: 16px;
                            position: absolute;
                            top: 42px;
                            left: 12px;
                        }

                        span {
                            font-size: 12px;
                            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                            ;
                            font-weight: 400;
                            color: #333333;
                            margin-top: 8px;
                            display: block;
                        }
                    }

                    .eva-rightInfo {
                        flex: 1;

                        .userName {
                            font-size: 14px;
                            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                            ;
                            font-weight: 400;
                            color: #202020;
                            margin-bottom: 12px;
                        }

                        .eva-rate {
                            display: flex;
                            align-items: center;

                            .eva-item {
                                font-size: 14px;
                                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                                ;
                                font-weight: 400;
                                color: #999999;
                                margin-right: 38px;
                                display: flex;
                                align-items: center;
                                margin-bottom: 16px;

                                span {
                                    margin-right: 4px;
                                }
                            }
                        }

                        .eva-content {
                            width: 100%;
                            min-height: 30px;
                            box-sizing: border-box;
                            padding: 10px;
                            background: #f5f5f5;
                            border-radius: 2px;
                            font-size: 14px;
                            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                            ;
                            font-weight: 400;
                            color: #333333;
                            margin-bottom: 21px;
                        }

                        .eva-time {
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: flex-end;
                            font-size: 14px;
                            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                            ;
                            font-weight: 400;
                            color: #999999;
                        }
                    }
                }

                .onther-goods {
                    width: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    padding-left: 10px;

                    .item-goods {
                        width: 225px;
                        height: 314px;
                        display: flex;
                        flex-direction: column;
                        box-sizing: border-box;

                        margin-bottom: 37px;

                        img {
                            width: 196px;
                            height: 196px;
                            margin: 0 auto;
                        }

                        .goods-name {
                            -webkit-line-clamp: 2;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            font-size: 14px;
                            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                            ;
                            font-weight: 400;
                            color: #333333;
                            margin-bottom: 24px;
                            margin-top: 15px;
                            padding: 0 15px;
                        }

                        .goods-price {
                            font-size: 18px;
                            font-family: Microsoft YaHei;
                            font-weight: bold;
                            color: #ec212d;
                            padding: 0 15px;
                        }

                        .goods-price::before {
                            content: "¥";
                            font-size: 12px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            margin-right: 2px;
                        }
                    }

                    .item-goods:hover {
                        z-index: 2;
                        -webkit-box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
                        box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
                        -webkit-transform: translate3d(0, -2px, 0);
                        transform: translate3d(0, -2px, 0);
                    }
                }
            }
        }
    }
</style>
<style lang="scss">
    .stockDetails {
        .searchIpt {
            position: absolute;
            right: 30px;

            .searchBtn {
                caret-color: transparent;
                width: 69px;
                height: 30px;
                line-height: 30px;
                text-align: center;
            }

            .searchBtn:hover {
                color: #fff;
                background-color: #EC212D;
            }

            .el-input {
                width: 360px;
                height: 32px;

                 .el-input-group__append:hover {
                    cursor: pointer;
                }

                 .el-input-group__append {
                    padding: 0;
                    background-color: #fff;
                    color: #333;
                }
            }

            .el-input__inner {
                height: 32px;
            }

            .el-input__icon {
                line-height: 32px;
                color: #EC212D;
            }
        }
    }
    .breadcrumb {
        .el-breadcrumb {
            height: 46px;
            line-height: 46px;
        }
        }

        .mouse-cover-canvas {
            position: relative;
            width: 500px;
            height: 500px;
            margin-top: 195px;
            // margin-left:13%;
            z-index: 1;
            left: 43% !important;
        }

        .magnifier-box img {
            width: 100%;
            height: 100%;
        }

        .goods-distribution .el-input__inner {
            width: 200px;
            padding-left: 30px;
        }

        .goods-distribution .el-input {
            width: 200px;
        }

        .goods-supplier .el-rate__icon {
            font-size: 18px;
            margin-right: 0px;
        }

        .eva-item .el-rate__icon {
            font-size: 18px;
            margin-right: 0px;
        }

        .select .el-input__inner {
            width: 120px;
        }

        .select .el-input {
            width: 120px;
        }

        .goods-introduce .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
            border-bottom-color: #ec212d;
            border-bottom-width: 2px;
        }

        .goods-payButton .el-input-number .el-input {
            width: 170px;
            // height: 45px;
        }

        .goods-payButton .el-input-number .el-input__inner {
            width: 170px;
            height: 42px;
            line-height: 42px;
            padding: 0 42px;
        }

        /* 主要内容CSS */
        #details .main {
            width: 1220px;
              padding-bottom: 40px;
            margin: 0 auto;
        }

        #details .main .block {
            float: left;
            width: 560px;
            height: 560px;
        }

        #details .el-carousel .el-carousel__indicator .el-carousel__button {
            background-color: rgba(163, 163, 163, 0.8);
        }

        #details .main .content {
            float: left;
            margin-left: 25px;
            /* width: 640px; */
            flex: 1;
        }

        #details .main .content .name {
            height: 68px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #333333;
        }

    /* 主要内容CSS END */
</style>
<style lang="scss">
    /**商品详情下方商品介绍 */
    .comdity-detail {
        .el-submenu__title {
            height: 40px;
            line-height: 40px;
            // text-align: center;
            font-size: 12px;
            color: #333;
        }

        .el-submenu__title:hover {
            background: #f3f3f3;
        }

        .el-menu {
            border: none;
        }

        .el-menu-vertical-demo {}

        .el-menu-item {
            height: auto;
            line-height: 36px;
            // height: auto !important;
            display: flex;
            flex-wrap: wrap;
            font-size: 12px;
            text-align: center;
            padding: 0 !important;
            background-color: #fff !important;

            .el-checkbox__label {
                font-size: 12px;
                color: #666;
            }
        }

        .el-menu-item-group__title {
            padding: 0;
        }

        .same-goods-list {
            .el-table__body-wrapper {
                caret-color: transparent;
                // overflow-y: auto;

                .cell {
                    height: 100px;
                }

                .el-input-number__decrease,
                .el-input-number__increase {
                    height: 34px;
                    line-height: 34px;
                }

                .el-input--small .el-input__inner {
                    caret-color: #000;
                    height: 36px;
                    line-height: 36px;
                }
            }
        }
    }
</style>
